<template>
  <nav class="navbar navbar-default">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-fill btn-icon" @click="minimizeSidebar">
          <i :class="$sidebar.isMinimized ? 'ti-menu-alt' : 'ti-more-alt'"></i>
        </button>
      </div>
      <div class="navbar-header">
        <button type="button" class="navbar-toggle" :class="{toggled: $sidebar.showSidebar}" @click="toggleSidebar">
          <span class="sr-only">Toggle navigation</span>
          <span class="icon-bar bar1"></span>
          <span class="icon-bar bar2"></span>
          <span class="icon-bar bar3"></span>
        </button>
        <!--<a class="navbar-brand">{{$t(this.$route.name)}}</a>-->
        <a class="navbar-brand">MySemeq</a>
      </div>
      <div class="collapse navbar-collapse">
        <!--
        <form class="navbar-form navbar-left navbar-search-form" role="search">
          <div class="input-group">
            <input type="text" value="" class="form-control" placeholder="Search...">
            <span class="input-group-addon"><i class="fa fa-search"></i></span>
          </div>
        </form>
        <div style="margin-top: 20px; float: left; cursor:pointer;" class="btn-magnify">
          <i class="fa fa-filter fa-2x"></i>
        </div>
        -->
        <ul class="nav navbar-nav navbar-right">
          <!--
          <li class="open">
            <router-link to="/admin/stats" class="dropdown-toggle btn-magnify" data-toggle="dropdown">
              <i class="ti-panel"></i>
              <p>Stats</p>
            </router-link>
          </li>
          <drop-down tag="li" title="5" icon="ti-bell">
            <li><a href="#">Notification 1</a></li>
            <li><a href="#">Notification 2</a></li>
            <li><a href="#">Notification 3</a></li>
            <li><a href="#">Notification 4</a></li>
            <li><a href="#">Another notification</a></li>
          </drop-down>
          -->
          <!-- <li v-if="isAuthenticated" @click="logout">
            <router-link to="/admin/overview" class="btn-magnify">
              <i class="ti-power-off"></i> {{ $t("logout") }}
            </router-link>
          </li>  -->         
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { AUTH_LOGOUT } from '../../../store/actions/auth'

export default {
  data () {
    return {
      activeNotifications: false
    }
  },
  name: 'navigation',
  methods: {
    capitalizeFirstLetter (string) {
      return string.charAt(0).toUpperCase() + string.slice(1)
    },
    toggleNotificationDropDown () {
      this.activeNotifications = !this.activeNotifications
    },
    closeDropDown () {
      this.activeNotifications = false
    },
    toggleSidebar () {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
    },
    hideSidebar () {
      this.$sidebar.displaySidebar(false)
    },
    minimizeSidebar () {
      this.$sidebar.toggleMinimize()
    },
    logout: function () {
      this.$store.dispatch(AUTH_LOGOUT).then(() => this.$router.push('/login'))
    }
  },
  computed: {
    ...mapGetters(['getProfile', 'isAuthenticated', 'isProfileLoaded']),
    ...mapState({
      authLoading: state => state.auth.status === 'loading',
      name: state => `${state.user.profile.title} ${state.user.profile.name}`
    })
  }
}

</script>
<style>
.navbar-header .navbar-toggle {
  margin-top: 5px!important;
}
/*.main-panel .navbar{width: 86%!important}*/
.main-panel > .content {
  padding: 20px 15px 0 15px!important;
}
.main-panel .navbar {
  height: 61px!important;
  background-color: #000!important;
  z-index: 102!important;
  width: 100%!important;
}
.navbar{
  min-height: 50px!important;
}
.navbar .navbar-minimize{
  margin-left: -14px;
}
.navbar .navbar-minimize .btn {
  margin: 6px 3px!important;
}
.navbar .navbar-brand{
  margin: 0px 0px!important;
  font-size: 15px!important;
  padding: 13px 15px!important;
}
.btn.btn-icon, .navbar .navbar-nav > li > a.btn.btn-icon {
  border-radius: 26px!important;
  padding: 3px 6px!important;
}
.navbar .navbar-nav > li > a {
  margin: 14px 0px!important;
  padding: 0px 15px!important;
}
.navbar-default{
  background-color: transparent;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/TopNavbar.vue